module.exports = __webpack_public_path__ + "assets1775130923925/img/robot-icon.9f96aeec.png";